export default () => {
    document.addEventListener('facetwp-loaded', () => {
        const facetWrappers = document.querySelectorAll('.facet-wrap')
        facetWrappers?.forEach((facetWrapper) => {
            const facets = facetWrapper?.querySelector('.facetwp-facet')
            facetWrapper.removeAttribute('style')

            if (!facets.hasChildNodes()) {
                facetWrapper.style.display = 'none'
            }
        })
    });

    // Select the single apply button using the data-component attribute
    const button = document.querySelector('[data-component="facet-apply"]');

    if (button) {
        button.addEventListener('click', () => {
            const closeButton = document.querySelector('.mfp-close');
            if (closeButton) {
                closeButton.click();
            }
        });
    }
}